(function($){
    $('.floatingNumber_number').on('click',function(e){
        const box = $(this).parent().find('.floatingNumber_text')
        const condition = box.hasClass('expandedBox')
        let heightAdhuster = $(this).parent().attr('style')
        heightAdhuster = heightAdhuster.substring(4, heightAdhuster.indexOf('%'))
        //use height adjuster to show snippet on top
        $('.elevated').removeClass('elevated')
        $(this).parent().addClass('elevated')
        if(e.pageX > window.innerWidth / 2) box.addClass('alignToRight')
        if(heightAdhuster > 70) box.addClass('alignToTop')
        $('.expandedBox').removeClass('expandedBox').addClass('shrinkedBox')
        if(!condition) setTimeout(()=>box.removeClass('shrinkedBox').addClass('expandedBox'),1)
        if( window.innerWidth < 700 && (e.pageX > window.innerWidth / 4 && e.pageX < (window.innerWidth / 4) * 3 ) ){
            box.css( 'maxWidth', (e.pageX > window.innerWidth / 2 ? window.innerWidth - e.pageX : e.pageX) + 'px')
        }
    })
    $('.foldableSection').on('click',function(){
        const arrow = $(this).find('.foldableTextArrow')
        const text = $(this).find('.foldableText')
        const miniBulletsTitle = $(this).find('.miniBulletTitle')
        console.log(miniBulletsTitle.length)
        if(arrow.hasClass('animateDown') ){
            arrow.removeClass('animateDown').addClass('animateUp')
            text.removeClass('expandedSlim expanded').addClass(miniBulletsTitle.length ? 'foldedSlim' : 'folded')
            miniBulletsTitle.removeClass('miniBulletTitleFat').addClass('miniBulletTitleSlim')
        } else {
            arrow.removeClass('animateUp')
            text.removeClass('folded foldedSlim')
            miniBulletsTitle.removeClass('miniBulletTitleSlim')
            setTimeout(()=>{
                arrow.addClass('animateDown')
                text.addClass(miniBulletsTitle.length ? 'expandedSlim' : 'expanded')
                miniBulletsTitle.addClass('miniBulletTitleFat')
            },1)
        }
    })
    $('.closeButton').on('click',()=>{
        $('.bdmPopUp').css('display','none')
    })
    $('.bdm-contact').on('click',e=>{
        e.stopPropagation()
        e.preventDefault()
        $('.bdmPopUp').css('display','flex')
    })
    $('.textOnlySlider').slick({
        infinite: true,
        slidesToShow: 3,
        autoplay:true,
        responsive:[
            { 
                breakpoint:900, 
                settings:{ 
                    slidesToShow: 2, 
                    autoplay:true, 
                },
            },
            { 
                breakpoint:620, 
                settings:{ 
                    slidesToShow: 1, 
                    autoplay:true,
                },
            },
        ],
    })
    $('.tripleCTALinkWraper').on('click',function(e){
        e.preventDefault()
        $(this).find('.tripleCtaBoxDark').toggleClass('foldedDarkBox')
    })
})(jQuery)



// WEBPACK FOOTER //
// ./scripts/custom-page-design.js